import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id
    }

    const path = '/entities/';
    const paths = {
        endpointSave: config.endpoints.backend + 'entities/save',
        endpointGetById: config.endpoints.backend + 'entities/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAll: config.endpoints.backend + 'entities/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Entidade",
        labelTitleEdit: "Editar Entidade",
        labelTitleView: 'Visualizar Entidade'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !profileFilter.pdc_company_id ? {
                    name: 'pdc_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'cnpj',
                    type: 'CNPJ',
                    label: 'CNPJ',
                    validations: {
                        required: true,
                        cnpj_unique: true
                    },
                    columnSize: 12
                },
                {
                    name: 'corporate_name',
                    type: 'text',
                    label: 'Razão social',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome Fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'municipal_registration',
                    type: 'text',
                    label: 'Inscrição Municipal',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'estadual_registration',
                    type: 'text',
                    label: 'Inscrição Estadual',
                    mask: '999.999.999.999',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'share_capital',
                    type: 'decimal',
                    label: 'Capital Social',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'cnae',
                    type: 'text',
                    label: 'CNAE',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'link',
                    type: 'text',
                    label: 'Link',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'phone_1',
                    type: 'phone',
                    label: 'Telefone 1',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'phone_2',
                    type: 'phone',
                    label: 'Telefone 2',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                cnpj_unique: async (value, options, key, attributes) => {
                    const pdc_company_id = attributes.pdc_company_id || profileFilter.pdc_company_id

                    if (value.length >= 18 && pdc_company_id) {
                        const cnpjExists = await Fetch.post(paths.endpointGetAll, {
                            filter: {
                                pdc_company_id,
                                cnpj: value, ...profileFilter
                            }, deleted: true
                        })

                        if (cnpjExists.length > 0) {
                            if (id && cnpjExists[0].id == id) {
                                return '';
                            } else {
                                if (cnpjExists[0].deleted == 1) {
                                    return '^Existem registros de entidades deletados com esse CNPJ, crie um chamado para administração se necessário.';
                                } else {
                                    return '^Já existe uma entidade cadastrada com esse CNPJ.';
                                }
                            }
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
